/* eslint-disable @typescript-eslint/prefer-enum-initializers */
/* eslint-disable @typescript-eslint/naming-convention */
export const enum FileType {
  AssetsFile,
  BundleFile,
  WebFile,
  ResourceFile,
  GZipFile,
  BrotliFile,
  ZipFile
}
